import { updatesData } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[900px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            更新快讯
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base max-w-[500px] mx-auto">
            站点内容实时更新动态，不错过每一部好片
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-[19px] md:left-[23px] top-2 bottom-2 w-0.5 bg-background-200"></div>

          <div className="space-y-6">
            {updatesData.map((item) => (
              <div key={item.id} className="relative flex gap-5 md:gap-6 pl-12 md:pl-14">
                <div className={`absolute left-0 w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full border-2 bg-background-50 z-10 ${
                  item.tag === '新片上线' ? 'border-primary-300 text-primary-500' :
                  item.tag === '剧集更新' ? 'border-accent-300 text-accent-500' :
                  'border-secondary-300 text-secondary-500'
                }`}>
                  <i className={`text-sm md:text-base ${
                    item.tag === '新片上线' ? 'ri-movie-2-line' :
                    item.tag === '剧集更新' ? 'ri-tv-2-line' :
                    item.tag === '功能升级' ? 'ri-tools-line' :
                    item.tag === '片库扩容' ? 'ri-database-2-line' :
                    item.tag === '专题策划' ? 'ri-stack-line' :
                    'ri-fire-line'
                  }`}></i>
                </div>

                <div className="flex-1 pb-1">
                  <div className="flex items-center gap-3 flex-wrap mb-1.5">
                    <span className="text-xs text-foreground-500 whitespace-nowrap">
                      {item.date}
                    </span>
                    <span className={`px-2 py-0.5 rounded-full text-[10px] font-medium whitespace-nowrap ${
                      item.tag === '新片上线' ? 'bg-primary-100 text-primary-700' :
                      item.tag === '剧集更新' ? 'bg-accent-100 text-accent-700' :
                      item.tag === '功能升级' ? 'bg-secondary-100 text-secondary-700' :
                      item.tag === '片库扩容' ? 'bg-primary-100 text-primary-700' :
                      item.tag === '专题策划' ? 'bg-accent-100 text-accent-700' :
                      'bg-primary-100 text-primary-700'
                    }`}>
                      {item.tag}
                    </span>
                  </div>
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900">
                    {item.title}
                  </h3>
                  <p className="mt-1.5 text-xs md:text-sm text-foreground-600 leading-relaxed">
                    {item.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}